import { FC } from "react";
import { Flex, Spinner } from "@contentful/f36-components";

export const Loading: FC = () => {
    return (
        <Flex flexDirection="column">
            <Spinner size="small" variant="primary" />
        </Flex>
    );
};
